<template>
  <div class="filtro-agrupado">
    <p class="title">{{ componentData.title }}</p>

    <div
      v-for="contrato in componentData.elements"
      :key="contrato.id"
      class="contrato-bloco"
    >
      <label class="contrato-label">
        <input
          type="checkbox"
          :checked="isContratoSelecionado(contrato)"
          @change="toggleContrato(contrato, $event.target.checked)"
          :ref="setCheckboxRef(contrato.id)"
        />
        <strong>{{ contrato.name }}</strong>
        <span class="contrato-id">({{ contrato.id }})</span>
      </label>

      <div class="beneficiarios">
        <label
          v-for="(ben, i) in contrato.beneficiarios"
          :key="`${contrato.id}-${ben.chaveUnica}-${i}`"
          class="beneficiario-label"
        >
          <input
            type="checkbox"
            :checked="isBeneficiarioSelecionado(contrato.id, ben.chaveUnica)"
            @change="toggleBeneficiario(contrato, ben, $event.target.checked)"
          />
          <div>
            <div>{{ ben.nome }}</div>
            <span>{{ ben.chaveUnica }} • {{ ben.tipoUsuario }}</span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterComponentAgrupado',
  props: {
    componentData: {
      type: Object,
      required: true
    },
    selected: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selecionados: [],
      checkboxRefs: {}
    }
  },
  watch: {
    selected: {
      immediate: true,
      handler (val) {
        this.selecionados = Array.isArray(val) ? val.slice() : []
        this.$nextTick(this.atualizaIndeterminate)
      }
    }
  },
  methods: {
    setCheckboxRef (id) {
      return el => {
        if (el) this.checkboxRefs[id] = el
      }
    },

    isContratoSelecionado (contrato) {
      if (this.selecionados.some(s => s.contrato === contrato.id && !s.chaveUnica)) {
        return true
      }
      const todos = contrato.beneficiarios.map(b => `${b.chaveUnica}-${contrato.id}`)
      return todos.every(m => this.selecionados.some(s => s.id === m))
    },

    isBeneficiarioSelecionado (contratoId, chaveUnica) {
      return this.selecionados.some(s => s.id === `${chaveUnica}-${contratoId}`)
    },

    isParcialmenteSelecionado (contrato) {
      const total = contrato.beneficiarios.length
      const marcados = contrato.beneficiarios.filter(b =>
        this.isBeneficiarioSelecionado(contrato.id, b.chaveUnica)
      ).length
      return marcados > 0 && marcados < total
    },

    toggleContrato (contrato, checked) {
      if (checked) {
        const novos = [
          ...this.selecionados.filter(s => s.contrato !== contrato.id),
          { contrato: contrato.id }
        ]
        this.selecionados = novos
      } else {
        this.selecionados = this.selecionados.filter(s => s.contrato !== contrato.id)
      }
      this.emitUpdate()
    },

    toggleBeneficiario (contrato, ben, checked) {
      const id = `${ben.chaveUnica}-${contrato.id}`

      if (checked) {
        this.selecionados.push({
          id,
          contrato: contrato.id,
          chaveUnica: true
        })
        this.selecionados = this.selecionados.filter(
          s => !(s.contrato === contrato.id && !s.chaveUnica)
        )
      } else {
        this.selecionados = this.selecionados.filter(s => s.id !== id)
      }

      const temAlgum = contrato.beneficiarios.some(b =>
        this.selecionados.some(s => s.id === `${b.chaveUnica}-${contrato.id}`)
      )
      if (!temAlgum) {
        this.selecionados = this.selecionados.filter(
          s => !(s.contrato === contrato.id && !s.chaveUnica)
        )
      }
      this.emitUpdate()
    },

    emitUpdate () {
      const mapa = new Set()
      this.selecionados = this.selecionados.filter(sel => {
        const chave = sel.id || sel.contrato
        if (mapa.has(chave)) return false
        mapa.add(chave)
        return true
      })

      this.$emit('update:selected', this.selecionados)
      this.$nextTick(this.atualizaIndeterminate)
    },

    atualizaIndeterminate () {
      this.componentData.elements.forEach(contrato => {
        const el = this.checkboxRefs[contrato.id]
        if (el) el.indeterminate = this.isParcialmenteSelecionado(contrato)
      })
    }
  }
}
</script>

<style scoped>
.filtro-agrupado {
  display: flex;
  flex-direction: column;
  font-family: "Helvetica Neue", Arial, sans-serif;
  color: #222;
}

.contrato-bloco {
  padding-bottom: 10px;
}

.contrato-label {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  cursor: pointer;
  color: #000;
}

.contrato-label strong {
  font-size: 15px;
}

.contrato-id {
  font-size: 12px;
  color: #777;
  font-weight: normal;
  margin-left: 4px;
}

.beneficiarios {
  margin-top: 10px;
  padding-left: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.beneficiario-label {
  display: flex;
  align-items: flex-start;
  font-size: 14px;
  color: #333;
  cursor: pointer;
}

.beneficiario-label input[type="checkbox"] {
  margin-top: 3px;
}

.beneficiario-label span {
  display: block;
  font-size: 12px;
  color: #777;
}
</style>
